
const type = 1;

export const triggerState = ({state,property,payload,namespace}) =>{
    if(type == 1){
        ////console.log(`${namespace} / ${property}=>${payload}`)
        // //console.log(`${namespace} / ${property}=>${JSON.stringify(payload)}`)
        state[property] = payload;
    }else{
        localStorage.setItem(namespace+'/'+property,payload)
    }
}

export const handleChange = ({states,namespace}) => {
    if(type == 1) {
        return states
    }else{
        let newState = {...states};
        for(let i in newState){
            newState[i] = localStorage.getItem(`${namespace}/${i}`)
        }
        return newState
    }
}




// WEBPACK FOOTER //
// ./src/store/config/index.js